import { Loader2 } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

const ProcessingModal = ({ open }: { open: boolean }) => {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-md flex flex-col items-center justify-center p-6">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-12 w-12 animate-spin text-primary" />
          <div className="text-center space-y-2">
            <h3 className="text-lg font-semibold">Transaction Processing</h3>
            <p className="text-sm text-muted-foreground">
              Please wait while your transaction is processed on-chain...
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProcessingModal;
